import { LoadingOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { groupListStore } from "Pages/Project/Groups/Stores/GroupsStore";
import { userInfoStore } from "Stores";
import { contactsStore } from "Stores/ContactsStore";
import { extractIdFromUId } from "../utils/extractIdFromUId";
import { formatUsername } from "utils/formatUsername";

interface EmailValueProps {
  uid: string;
  backupName?: API_MailAndName;
}

export const EmailValue = observer((props: EmailValueProps) => {
  if (contactsStore.state === "LOADING") {
    return <LoadingOutlined />;
  }
  const forRestrictedUser = !userInfoStore.allowedToChangeSetting;

  const contact = extractIdFromUId(props.uid);
  let name;
  if (contact.type !== "email") {
    let contactListToSearch: (API_Contact & API_User)[];
    if (contact.type === "user") {
      contactListToSearch = contactsStore.projectUsers;
    } else if (contact.type === "contact") {
      contactListToSearch = contactsStore.userContacts;
    } else if (contact.type === "group") {
      contactListToSearch = groupListStore.asArray;
    } else if (contact.type === "deactivated") {
      contactListToSearch = contactsStore.projectUsers;
    } else {
      throw new Error("Unknown contact type");
    }
    const foundContact = contactListToSearch.find((item) => item.id === contact.value);
    if (foundContact) {
      if (forRestrictedUser) {
        // if user - is restricted user
        if (foundContact.email) {
          name = foundContact.email;
        } else {
          name = null;
        }
      }
      name = `${formatUsername({ firstName: foundContact.firstName, surname: foundContact.surname })}`;
      if (foundContact.email) {
        name += ` (${foundContact.email})`;
      }
    } else {
      name = null;
    }
  } else {
    name = contact.value;
  }

  if (!name) {
    if (props.backupName) {
      name = `${props.backupName.name} (${props.backupName.email})`;
    } else {
      name = "Email not found";
    }
  }

  return name;
});

export function getEmailFromUid(uid: string) {
  if (contactsStore.state === "LOADING") {
    return <LoadingOutlined />;
  }
  const forRestrictedUser = !userInfoStore.allowedToChangeSetting;

  const contact = extractIdFromUId(uid);
  let name;
  if (contact.type !== "email") {
    let contactListToSearch: API_Contact[];
    if (contact.type === "user" || contact.type === "deactivated") {
      contactListToSearch = contactsStore.projectUsers;
    } else if (contact.type === "contact") {
      contactListToSearch = contactsStore.userContacts;
    } else if (contact.type === "group") {
      contactListToSearch = groupListStore.asArray;
    }
    const foundContact = contactListToSearch.find((item) => item.id === contact.value);
    if (foundContact) {
      if (forRestrictedUser) {
        // if user - is restricted user
        if (foundContact.email) {
          name = foundContact.email;
        } else {
          name = "Email not found";
        }
      }
      name = `${foundContact.name}`;
      if (foundContact.email) {
        name += ` (${foundContact.email})`;
      }
    } else {
      name = "Email not found";
    }
  } else {
    name = contact.value;
  }

  return name;
}
